import React from 'react'
import TextMessageDefault from './componsents/TextMessageDefault'
import ImageMessageDefault from './componsents/ImageMessageDefault'
import { MessageType, MessageItemType, MessageContent } from './interface'

import './index.css'

/**
 * 在页面中总是需要添加回复消息,所以封装一个组件用来简化这个操作
 * 1. 此组件接受一个 消息 数组, 然后这个组件遍历这个数组,返回对应的显示组件
 * 2. 并且需要传入一个回调函数,函数接受一个参数,这个参数就是用户修改的最新值
 */

interface WechatyMessageType {
    messageList: MessageItemType[]
    textMsgComponent?: typeof TextMessageDefault
    imageMsgComponent?: typeof ImageMessageDefault
    onChnage: (value: MessageContent, index: number) => void
    onDelete: (index: number) => void
}

class WechatyMessage extends React.Component<
    WechatyMessageType,
    { list: WechatyMessageType['messageList'] }
> {
    constructor(props: WechatyMessageType) {
        super(props)
        this.state = { list: [...props.messageList] }
    }
    renderMessage = (
        item: WechatyMessageType['messageList'][0],
        index: number
    ) => {
        switch (item.type) {
            case MessageType.TEXT:
                if (this.props.textMsgComponent) {
                    return React.createElement(this.props.textMsgComponent, {
                        key: item.key,
                        onChange: (e) => this.props.onChnage(e, index),
                        content: item.content,
                        onDelete: () => this.props.onDelete(index),
                    })
                }
                return (
                    <TextMessageDefault
                        key={item.key || item.id}
                        onChange={(e) => this.props.onChnage(e, index)}
                        content={item.content}
                        onDelete={() => this.props.onDelete(index)}
                    />
                )
            case MessageType.IMAGE:
                if (this.props.imageMsgComponent) {
                    return React.createElement(this.props.imageMsgComponent, {
                        key: item.key || item.id,
                        img_url: item.img_url,
                        onDelete: () => this.props.onDelete(index),
                    })
                }
                return (
                    <ImageMessageDefault
                        key={item.key || item.id}
                        img_url={item.img_url}
                        onDelete={() => this.props.onDelete(index)}
                    />
                )

            default:
                return null
        }
    }

    render() {
        return (
            <div className='messageList'>
                {this.props.messageList.map((item, index) =>
                    this.renderMessage(item, index)
                )}
            </div>
        )
    }
}

export default WechatyMessage
